import React from 'react'

export default function MoreInfo() {
  return (
    <div>Here we can but data that will not be changed</div>
  )
}
